<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('my.withdraw_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty
          v-if="list.length === 0"
          :description="$t('withdraw.empty_data')"
        />
        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="topInfo">
            <span :class="statusClass(v)">{{ v.status_text }}</span>
            <span class="money">-{{ v.money }}</span>
          </div>
          <div class="desc" v-if="v.desc">
            <span>{{ $t("withdraw.desc") }}：{{ v.desc }}</span>
          </div>
          <div class="time">
            <span>{{ $t("withdraw.submit_time") }}：{{ v.create_time }}</span>
          </div>
          <div class="time" v-if="v.update_time">
            <span>{{ $t("withdraw.check_time") }}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    statusClass(v) {
      const s = Number(v && v.status);
      if (s === 2 || s === 4) return "ok";
      if (s === 3) return "fail";
      return "pending";
    },
    onRefresh() {
      this.getUserWithdrawList(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      });
    },
    getUserWithdrawList(done) {
      this.$http({
        method: "get",
        url: "user_get_withdraw_list",
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data || [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        if (typeof done === "function") done();
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserWithdrawList();
    }
  },
};
</script>

<style lang="less" scoped>
.sub-page {
  min-height: 100vh;
  background: #000;
  padding-bottom: 40px;
}
.main {
  padding: 10px 0 20px;
}
::v-deep .van-empty__description {
  color: #979799;
}
.item_list {
  padding: 24px 28px;
  margin: 16px 24px;
  background: #141414;
  border-radius: 16px;
  border: 1px solid rgba(201, 168, 76, 0.35);
  line-height: 1.6;
}
.topInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 30px;
  font-weight: 700;
  .ok {
    color: #07c160;
  }
  .fail {
    color: #ee0a24;
  }
  .pending {
    color: #c9a84c;
  }
  .money {
    color: #c9a84c;
  }
}
.desc,
.time {
  font-size: 24px;
  color: #979799;
  margin-top: 6px;
}
</style>
